module.exports = "fragment VerifyPhoneNumberSuccessFragment on VerifyPhoneNumberSuccess {\n  successType\n  verifiedAccount {\n    ...AccountFragment\n  }\n}\n"